import React from 'react';
import { InlineEdit, InlineEditTableWrapper } from '@nile/components';
import InlineSelect from '@nile/components/src/Components/InlineEdit/Components/InlineSelect';

function InlineEditTextCell(props) {
  const { _ticket, cell } = props;
  const ticket = _ticket || cell.row.original;
  const { actions, type, editable, clearable, shouldFreezeCell } = cell.column;
  const CELL_TYPE = type === 'Status' ? 'tag' : '';
  const isCellFreezed = shouldFreezeCell && shouldFreezeCell(cell);
  return (
    <>
      <InlineEditTableWrapper className="full-width" key={cell?.value}>
        <InlineEdit
          editable={!isCellFreezed && editable}
          autoSave
          showProgress
          editView={(fieldProps) => {
            return (
              <>
                <InlineSelect
                  {...props}
                  mode="edit"
                  updateFieldState={fieldProps.updateFieldState}
                  isClearable={clearable}
                />
              </>
            );
            // return <div>{defaultValue?.label || 'NA'}</div>;
          }}
          readView={() => {
            return <InlineSelect {...props} mode="view" type={CELL_TYPE} />;
          }}
          onConfirm={(value, callback) => {
            actions.save && actions.save(value, ticket, props.data, callback);
            // updateCell(value, null, null, callback);
          }}
        />
      </InlineEditTableWrapper>
    </>
  );
}

export default React.memo(InlineEditTextCell);
